import React from 'react';
import classes from './AuthRoute.module.scss';
import { useSearchParams, useNavigate } from 'react-router';
import { saveTokensAfterAuthentication } from 'helpers/cookies';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const AuthRoute = () => {
  const [errorText, setErrorText] = React.useState('');

  const { t } = useTranslation();
  
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const setTokensAndNavigateToMain = () => {
    const access_token = searchParams.get('access_token');
    const refresh_token = searchParams.get('refresh_token');
    const status = searchParams.get('status');

    const params = Object.fromEntries(searchParams.entries());
    console.log(params, '<< params');

    if (access_token && refresh_token) {
      saveTokensAfterAuthentication({access_token, refresh_token});
      navigate('/');
    } else if (status === 'success') {
      navigate('/');
    } else {
      console.log(params, '<< error params');
      setErrorText(t('external_auth.error_tokens'));
    }
  }
  
  React.useEffect(() => {
    setTokensAndNavigateToMain();
  }, []);

  return (
    <div className={classes.lds}>
      {
        errorText
          ? <div><div className={classes.exclamationWrap}><ExclamationCircleOutlined /></div><div>{errorText}</div></div>
          : <div className={classes.ldsRipple}><div></div><div></div></div>
      }
    </div>
  );
}

export default AuthRoute;
